import { render, staticRenderFns } from "./AddPartnerAdditional.vue?vue&type=template&id=3b09bffc&"
import script from "./AddPartnerAdditional.vue?vue&type=script&lang=js&"
export * from "./AddPartnerAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports